import type { ContactDataServiceModel } from '@core/services/contact-data/contact-data.service';
import type { ContactResource, RecipientEmailEnum } from '@wizbii/utils/models';

import { computed, inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { Store } from '@ngrx/store';
import { contactEmailKeys } from '@stores/services/services.selector';
import { identityCard, user } from '@stores/session/session-ngrx.selector';

@Injectable()
export class ContactDataServiceImpl implements ContactDataServiceModel {
  readonly #store = inject(Store);

  readonly #identityCard = this.#store.selectSignal(identityCard);
  readonly #user = this.#store.selectSignal(user);
  readonly #defaultEmailKey = this.#store.selectSignal(contactEmailKeys(environment.contactEmailKey.base));

  contactFormData = computed<ContactResource>(() => ({
    appId: environment.applicationId,
    recipientEmailKey: this.#defaultEmailKey() as RecipientEmailEnum,
    firstName: this.#identityCard().firstName,
    lastName: this.#identityCard().lastName,
    phone: this.#identityCard().mobile,
    email: this.#user()?.username ?? '',
    subject: '',
    content: '',
    mustSendCopy: false,
    attributes: {},
  }));
}
